import { Pipe, PipeTransform } from '@angular/core';
import { PaymentType } from '../../interfaces/payment';

@Pipe({
  name: 'paymentType'
})
export class PaymentTypePipe implements PipeTransform {

  transform(value: PaymentType): string {
    switch (value) {
      case PaymentType.FIXED:
        return 'Fixo';
      case PaymentType.VARIABLE:
        return 'Variável';
      default:
        return '---';
    }
  }

}
